import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";
import logo from "./images/spark-logo.png";

export default function NavBar() {
  const [open, setOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`nav ${open ? "open" : ""} ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-inner container">
        <img className=" text-uppercase" src={logo} alt="logo" />

        <button
          className={`burger  ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`menu ${open ? "show" : ""}`}>
          <Link
            to="/home"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            About
          </Link>
          <Link
            to="/services"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Services
          </Link>
          <Link
            to="/projects"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Projects
          </Link>
          <Link
            to="/clients"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Clients
          </Link>
          <Link
            to="/blog"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Blog
          </Link>
          <Link
            to="/contact"
            className="item text-uppercase"
            onClick={() => setOpen(false)}
          >
            Contact Us
          </Link>
        </nav>
      </div>
    </header>
  );
}
